import { NameIdModel } from '@ct/model';

export const tradeStatuses: Map<string, NameIdModel> = new Map()
  .set('Delivered', { name: 'Delivered', id: 'Delivered' })
  .set('In Transit', { name: 'In Transit', id: 'In Transit' })
  .set('Scheduled', { name: 'Scheduled', id: 'Scheduled' })
  .set('Loading', { name: 'Loading', id: 'Loading' });
